import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { DatePicker, Button, Form } from 'antd';
import MyPage from '../Page';
import TableSection from './component/table';
import FilterData from './component/filter';
import { FileSearchOutlined } from '@ant-design/icons';

export default ({ url, title, repType, FetchComponent, printHeaderReport, printFooterReport, onDataChange,
    onFilterChange, onDateChange, customExcelExport }) => {
    const [timestamp, setTimestamp] = useState(moment().unix());
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState(moment().add(1, 'day'));
    const [selectedValues, setSelectedValues] = useState([]);
    const [filterLists, setFilterLists] = useState([]);
    const curUrl = useMemo(() => {
        return `${startDate.format('YYYYMMDDHHmm')}/${endDate.format('YYYYMMDDHHmm')}`;
    }, [startDate, endDate]);
    const [uri, setUri] = useState(curUrl);

    const maxEndDate = useMemo(() => {
        const nextWeek = moment(startDate).add(7, 'day');
        return (nextWeek.unix() > moment().add(1, 'day').unix()) ? moment().add(1, 'day') : nextWeek;
    }, [startDate]);

    useEffect(() => {
        if (endDate.startOf('date').unix() > maxEndDate.startOf('date').unix()) {
            setEndDate(maxEndDate);
        }
    }, [maxEndDate])

    useEffect(() => {
        onFilterChange && typeof onFilterChange === 'function' && onFilterChange(selectedValues);
    }, [selectedValues])

    useEffect(() => {
        onDateChange && typeof onDateChange === 'function' && onDateChange(startDate, endDate);
    }, [startDate, endDate])

    const DailyBtn = () => (
        <Form layout='inline'>
            <Form.Item label="Start Date">
                <DatePicker
                    value={startDate}
                    format='DD-MMM-YYYY HH:mm'
                    showTime={{ format: 'HH:mm' }}
                    onChange={date => {
                        setStartDate(date);
                    }}
                    size='large'
                    allowClear={false}
                    style={{ marginInline: 5 }}
                />
            </Form.Item>
            <Form.Item label="End Date">
                <DatePicker
                    value={endDate}
                    format='DD-MMM-YYYY HH:mm'
                    showTime={{ format: 'HH:mm' }}
                    onChange={date => {
                        setEndDate(date);
                    }}
                    allowClear={false}
                    size='large'
                    style={{ marginInline: 5 }}
                />
            </Form.Item>
            <Form.Item>
                <Button
                    type='default'
                    color="primary"
                    icon={<FileSearchOutlined />}
                    onClick={() => {
                        setUri(curUrl);
                        setTimestamp(moment().unix());
                    }}
                >
                    Search
                </Button>
            </Form.Item>
        </Form>
    );
    return (
        <MyPage title={title}>
            <div style={{ display: 'flex', flexDirection: 'column', paddingBlock: 30 }}>
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 5, marginBottom: 16 }}>
                    <DailyBtn />
                </div>
                <FilterData
                    lists={filterLists}
                    idReport={`${url}${repType}`}
                    onFilterValueChange={fval => {
                        setSelectedValues(fval);
                    }}
                />
                <TableSection
                    date={uri}
                    baseUrl={url}
                    FetchComponent={FetchComponent}
                    repType={repType}
                    timestamp={timestamp}
                    selectedValue={selectedValues}
                    setFilterLists={setFilterLists}
                    printHeader={printHeaderReport}
                    printFooter={printFooterReport}
                    onDataChange={onDataChange}
                    title={title}
                    customExcelExport={customExcelExport}
                />
            </div>
        </MyPage>
    )
}
